/*
 * @Author: zyy
 * @Date: 2022-04-01 13:31:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-02-21 12:38:15
 * @Description: default
 */

import Axios from "axios";
import Qs from 'qs'
export default {
    // 添加工单
    add(
        community_id,
        source,
        category_id,
        contacts,
        mobile,
        staff_id,
        body
    ) {
        return Axios.post('/community/api/admin/tsjy/propose/add', {
            community_id,
            source,
            category_id,
            contacts,
            mobile,
            staff_id,
            body
        })
    },

    // 工单列表
    list(
        work_no,
        category_id,
        community_id,
        contacts,
        mobile,
        status,
        staff_id,
        page,
        per_page
    ) {
        return Axios.get('/community/api/admin/tsjy/propose/list', {
            params: {
                work_no,
                category_id,
                community_id,
                contacts,
                mobile,
                status,
                staff_id,
                page,
                per_page
            },
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    // 工单详情
    detail(id) {
        return Axios.get(`/community/api/admin/tsjy/propose/detail/${id}`)
    },
    // 分配工单
    assign(params) {
        return Axios.post(`/community/api/admin/tsjy/propose/assign/${params.id}`, params)
    },
    // 关闭工单
    cancel(id, cancel_reason) {
        return Axios.post(`/community/api/admin/tsjy/propose/cancel/${id}`, {
            cancel_reason
        })
    },
    // 确认处理工单
    confirm(id) {
        return Axios.post(`/community/api/admin/tsjy/propose/confirm/${id}`)
    },
    // 完成工单
    handleFinish(id) {
        return Axios.post(`/community/api/admin/tsjy/propose/handleFinish/${id}`)
    },
    // 回访
    returnVisit(id, return_status, return_explain) {
        return Axios.post(`/community/api/admin/tsjy/propose/returnVisit/${id}`, {
            return_status,
            return_explain
        })
    },
    // 完结
    finish(id) {
        return Axios.post(`/community/api/admin/tsjy/propose/finish/${id}`)
    }

}